import PdfSettingsContainer from './PdfSettingsContainer';

export default PdfSettingsContainer;
